"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var money_symbols_1 = require("./money.symbols");
var money_currencies_1 = require("./money.currencies");
var index_1 = require("./index");
exports.SYMBOL_FORMAT_INT = '[[FormatInt]]';
exports.SYMBOL_FORMAT_DECIMAL = '[[FormatDecimal]]';
var MoneyImpl = /** @class */ (function () {
    function MoneyImpl(amount, currency, decimals) {
        this.amount = amount || 0;
        this.currency = currency;
        this.symbol = money_symbols_1.MONEY_SYMBOLS[currency] || currency;
        try {
            this.decimals = typeof decimals === 'number' ? decimals : money_currencies_1.MONEY_CURRENCIES[currency].minorUnit;
        }
        catch (e) {
            this.decimals = 2;
        }
    }
    MoneyImpl.prototype.formatIntl = function (locale, options) {
        if (locale === void 0) { locale = navigator.language; }
        if (options === void 0) { options = {}; }
        try {
            return new Intl.NumberFormat(locale, __assign({}, options, { style: 'currency', currency: this.currency })).format(this.formatAmount());
        }
        catch (e) {
            return this.formatAmountWithSymbol();
        }
    };
    /**
     * Get amount with currency -> 150000/EUR|2
     */
    MoneyImpl.prototype.formatToRawString = function () {
        return this.amount + "|" + this.currency + "|" + this.decimals;
    };
    /**
     * Get amount without symbol and comma separation -> 1500.00
     */
    MoneyImpl.prototype.formatAmount = function () {
        return this.amount / Math.pow(10, this.decimals);
    };
    /**
     * Get with symbol and comma separation -> € 1,500.00
     */
    MoneyImpl.prototype.formatAmountWithSymbol = function () {
        var value = this.formatToParts();
        return this.symbol + " " + value.string.integer + "." + value.string.decimal;
    };
    /**
     * Split amount in integer and decimal values
     */
    MoneyImpl.prototype.formatToParts = function () {
        var _a = this.formatAmount().toFixed(this.decimals).split('.'), int = _a[0], decimal = _a[1];
        return {
            number: { integer: +int, decimal: +decimal },
            string: { integer: this[exports.SYMBOL_FORMAT_INT](int, ','), decimal: this[exports.SYMBOL_FORMAT_DECIMAL](decimal) }
        };
    };
    /**
     * Sum two Money
     */
    MoneyImpl.prototype.sum = function (instanceToSum) {
        this.throwErrorForSumAndSub(instanceToSum);
        return index_1.createMoney({
            amount: this.amount + instanceToSum.amount,
            currency: this.currency,
            decimals: this.decimals
        });
    };
    /**
     * Subtraction two Money
     */
    MoneyImpl.prototype.sub = function (instanceToSub) {
        this.throwErrorForSumAndSub(instanceToSub);
        return index_1.createMoney({
            amount: this.amount - instanceToSub.amount,
            currency: this.currency,
            decimals: this.decimals
        });
    };
    MoneyImpl.prototype[exports.SYMBOL_FORMAT_INT] = function (value, separator) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    };
    MoneyImpl.prototype[exports.SYMBOL_FORMAT_DECIMAL] = function (value) {
        if (!value) {
            return '0'.repeat(this.decimals);
        }
        return value.length < this.decimals ? "" + value + '0'.repeat(this.decimals - value.length) : value;
    };
    MoneyImpl.prototype.throwErrorForSumAndSub = function (instancePassed) {
        if (instancePassed.currency !== this.currency) {
            throw new Error("Currencies are different: received " + instancePassed.currency + ", expected " + this.currency);
        }
        if (instancePassed.decimals !== this.decimals) {
            throw new Error("Decimals are different: received " + instancePassed.decimals + ", expected " + this.decimals);
        }
    };
    return MoneyImpl;
}());
exports.MoneyImpl = MoneyImpl;
//# sourceMappingURL=money.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@qwentes/models/lib/packages/money/money.js
// module id = 256
// module chunks = 0